module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0020-f5e4e29c4f0f8107e1c71362298897f7.jpg";